import { inject, bindable, IEventAggregator } from 'aurelia';
import { getLogger } from '../../common/logging';
import { FormFieldChanged } from '../../messages/form-field-changed';
import { SumService } from '../../services/sum-service';
import { afterSiblingsBound, fieldOf } from '../../common/element-field';
import { elementId } from '../../common/element-id';

let log = getLogger('sum');

@inject(Element, SumService, IEventAggregator)
export class SumCustomAttribute {
  @bindable({ primary: true }) value;
  @bindable field;

  constructor(element, sumService, ea) {
    this.element = element;
    this.sumService = sumService;
    this.ea = ea;
  }

  binding() {
    if (!this.value) {
      log.warn(`No sum target specified. should be: sum="targetFieldName"`);
      return;
    }

    this.elementId = elementId(this.element);
    this.subscription = this.ea.subscribe(FormFieldChanged, (message) => {
      this.onFormFieldChanged(message);
    });
  }

  attached() {
    if (!this.value) return;

    afterSiblingsBound(() => this.registerField());
  }

  registerField() {
    const name = this.field || fieldOf(this.element)?.name;
    if (!name) {
      log.warn(`No field for sum target ${this.value}. The element needs form-field or sum="value: target; field: fieldName"`);
      return;
    }
    this.sumService.register(this.value, name);
  }

  onFormFieldChanged(message) {
    if (message.elementId !== this.elementId) return;
    const { model } = fieldOf(this.element);
    let sum = 0;

    for (let i of this.sumService.getItems(this.value)) {
      let v = parseInt(model[i], 10);
      if (isNaN(v)) continue;
      sum += v;
    }

    model[this.value] = sum;
  }

  detaching() {
    if (this.subscription) this.subscription.dispose();
  }
}


